export const isSellingWindowValid = (start?: string, end?: string) => {
    if (!start || !end) return false

    const now = new Date()
    const startDate = new Date(start)
    const endDate = new Date(end)

    return now >= startDate && now <= endDate
}
